import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
import { ContextProvider } from "./contexts/AllContext.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContextProvider>
      <App />
    </ContextProvider>
  </React.StrictMode>
);
